import { render } from "./BookingFormSubmitted.vue?vue&type=template&id=f8ab6428&scoped=true"
import script from "./BookingFormSubmitted.vue?vue&type=script&lang=js"
export * from "./BookingFormSubmitted.vue?vue&type=script&lang=js"

import "./BookingFormSubmitted.vue?vue&type=style&index=0&id=f8ab6428&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ab6428"]])

export default __exports__